<template>
	<label
		:class="margin"
		class="checkbox-switch">
		<div
			class="checkbox-switch__item"
			@click="disabledHandler"
			:class="mods"
		>
			<input
				:disabled="disabled"
				ref="fieldRef"
				v-model="togglerChecked"
				type="checkbox">
			<span class="rounded"></span>
		</div>
		<div v-if="label" class="field-label">{{ label }}</div>
	</label>
</template>

<script>
import {computed, onMounted, onUnmounted, ref} from 'vue';
import toggleValidators from "@/components/fields/validators/toggleValidators";
import emitter from "@/utils/emitter";
const {
	toggleBlockedValidator,
	showWarningValidator,
	makeRequestValidator,
	updateValidator
} = toggleValidators();
export default {
	props:{
		label: {
			type: String
		},
		checked: {
			type: Boolean,
			default: false
		},
		blocked: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		makeRequest: {
			type: Boolean,
			default: false,
		},
		showWarning: {
			type: Boolean,
			default: false,
		},
		mods: {
			type: String
		},
		margin: {
			type: String,
			default: '' // mb--44
		}
	},
	emits: {
		'toggle-blocked': toggleBlockedValidator,
		'show-warning': showWarningValidator,
		'make-request': makeRequestValidator,
		'disabled-action': () => true,
		'update:checked': updateValidator,
	},
	setup(props, {emit}) {
		const fieldRef = ref(null);
		const togglerChecked = computed({
			get() {return props.checked},
			set(value){
				manageToggled({
					blocked: props.blocked,
					warning: props.showWarning,
					request: props.makeRequest,
					value,
					inputHTML: fieldRef.value
				})
			}
		});
		
		function manageToggled({blocked, warning, request, value, inputHTML}){
			if(blocked && value){
				toggleBlocked();
				inputHTML.checked = false;
				return;
			}
			if(warning && !value) {
				inputHTML.checked = true;
				showWarning();
				return;
			}
			
			updateChecked(value);
			if(request) makeRequest(value);
		}

		function syncToggled(){
			// to change input value without user's interaction and make sure the right status is shown
			if(fieldRef.value) fieldRef.value.checked = props.checked;
		}
		
		function toggleBlocked(){
			emit('toggle-blocked');
		}
		function showWarning(){
			emit('show-warning');
		}
		function updateChecked(value){
			emit('update:checked', value);
		}
		function makeRequest(value){
			emit('make-request', value);
		}
		
		function disabledHandler(){
			if(props.disabled) emit('disabled-action');
		}

		onMounted(() => {
			emitter.on('syncToggled', syncToggled);
		})
		onUnmounted(() => {
			emitter.off('syncToggled', syncToggled);
		})
		
		return {
			togglerChecked,
			fieldRef,
			disabledHandler
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/base/fields/checkbox-switch";
</style>
